<template>
  <div
    class="admin-sample-dis-analysis"
    style="position: fixed; top: 70px; left: 10px"
  >
    <q-card
      :style="{
        width: `${
          currentTab === 'all' ? 240 : currentTab === 'group' ? 1000 : 1400
        }px`,
        maxWidth: 'calc(100vw - 20px)',
        maxHeight: 'calc(100vh - 100px)',
      }"
      class="bg-white q-pa-md tl-transition-1"
    >
      <q-item
        clickable
        class="full-width rounded-borders row items-center bg-secondary text-white"
      >
        <div class="full-width row items-center justify-center text-bold">
          <q-icon name="fas fa-calendar" size="16px" class="q-mr-sm" />
          <span>{{ date }}</span>
        </div>
        <q-menu :offset="[0, 5]" class="q-pa-none bg-transparent shadow-none">
          <q-date v-model="date" mask="YYYY-MM-DD">
            <div class="row items-center justify-end">
              <q-btn v-close-popup label="Close" color="primary" flat />
            </div>
          </q-date>
        </q-menu>
      </q-item>

      <q-tabs
        dense
        v-model="currentTab"
        class="q-mt-md"
        narrow-indicator
        active-color="primary"
      >
        <q-tab
          dense
          class="rounded-borders q-px-sm"
          :class="{
            'text-grey': currentTab !== 'all',
          }"
          name="all"
        >
          <div class="row no-wrap items-center">
            <q-icon v-if="currentTab !== 'all'" name="fas fa-clipboard-list" />
            <span v-else class="q-ml-sm">总体情况</span>
            <q-tooltip>总体情况</q-tooltip>
          </div>
        </q-tab>
        <q-tab
          dense
          class="rounded-borders q-px-sm"
          :class="{
            'text-grey': currentTab !== 'group',
          }"
          name="group"
        >
          <div class="row no-wrap items-center">
            <q-icon v-if="currentTab !== 'group'" name="fas fa-users" />
            <span v-else class="q-ml-sm">分组情况</span>
            <q-tooltip>分组情况</q-tooltip>
          </div>
        </q-tab>
        <q-tab
          dense
          class="rounded-borders q-px-sm"
          :class="{
            'text-grey': currentTab !== 'area_ind',
          }"
          name="area_ind"
        >
          <div class="row no-wrap items-center">
            <q-icon v-if="currentTab !== 'area_ind'" name="fas fa-industry" />
            <span v-else class="q-ml-sm">
              区域/行业
            </span>
            <q-tooltip>区域/行业</q-tooltip>
          </div>
        </q-tab>
      </q-tabs>
      <q-tab-panels keep-alive v-model="currentTab" class="bg-transparent">
        <q-tab-panel name="all">
          <AggStatus :date="date" />
        </q-tab-panel>
        <q-tab-panel name="group" class="column no-wrap">
          <AggStatusGroup :date="date" />
        </q-tab-panel>
        <q-tab-panel name="area_ind" class="column no-wrap">
          <AggAreaIndustry :date="date" />
        </q-tab-panel>
      </q-tab-panels>
    </q-card>
  </div>
</template>

<script>
const f = (str) => {
  for (let i = str.length; i < 2; i++) {
    str = "0" + str;
  }
  return str;
};

export default {
  components: {
    Loading: () => import("@/components/Loading"),
    Empty: () => import("@/components/Empty"),

    AggStatus: () => import("./aggs/AggStatus"),
    AggStatusGroup: () => import("./aggs/AggStatusGroup"),
    AggAreaIndustry: () => import("./aggs/AggAreaIndustry"),
  },
  data() {
    return {
      date: "",
      all: {},
      day: {},

      currentTab: "all",
    };
  },

  mounted() {
    const now = new Date();
    this.date = `${now.getFullYear()}-${f(`${now.getMonth() + 1}`)}-${f(
      `${now.getDate()}`
    )}`;
  },

  methods: {},
};
</script>

<style lang="scss">
@import "@/styles/quasar";
.admin-sample-dis-analysis {
  .q-menu {
    padding: 0 !important;
  }
  .q-card > div:not(:last-child),
  .q-card > img:not(:last-child) {
    border-bottom-left-radius: $generic-border-radius;
    border-bottom-right-radius: $generic-border-radius;
  }

  .chart-output {
    height: 250px;
  }

  .sticky-header-table {
    /* height: 310px; */
    border-radius: $generic-border-radius !important;
    box-shadow: $shadow-1;

    .q-table__top,
    .q-table__bottom,
    thead tr:first-child th {
      background-color: $grey-2;
    }

    .q-table__middle.q-virtual-scroll.scroll {
      overflow: hidden;
      transition: all 0.1s ease;
      &:hover {
        overflow: auto;
      }
    }

    thead tr th {
      position: sticky;
      z-index: 1;
    }
    thead tr:first-child th {
      top: 0;
    }

    /* this is when the loading indicator appears */
    &.q-table--loading thead tr:last-child th {
      /* height of all previous header rows */
      top: 48px;
    }
  }
}
</style>
